module.exports = __webpack_public_path__ + "static/media/can_logo_dark.5e3dfce5.svg";